import React, { useEffect, useRef, useState } from 'react';
import { getData, meUpdate, uploadFile } from '../api';
import FormUpdateUserField from '../components/FormUpdateUserField';
import BankAccountModal from '../components/Modals/BankAccountModal';
import MyPlansModal from '../components/Modals/MyPlansModal';
import { handleApiGlobalError, syncUser } from '../helpers/asyncActions';
import { getProfilePic } from '../helpers/images';
import { useGlobalContext } from '../stores/global';
import styles from './MeProfileSettings.module.scss';

export default function MeProfileSettings() {
  const { user, dispatch, isLoading } = useGlobalContext();
  const [formOptions, setFormOptions] = useState<Record<string, string[]>>();
  const inputRef = useRef<HTMLInputElement>(null);
  const isSeller = user?.role === 'vendedor';
  const [showBankAccountModal, setShowBankAccountModal] = useState(false);
  const [showMyPlansModal, setShowMyPlansModal] = useState(false);

  useEffect(() => {
    syncUser(dispatch)
      .then(getData)
      .then((response) => {
        setFormOptions(response.data.data);
      })
      .catch(handleApiGlobalError.bind(null, dispatch));
  }, []);

  const handleUpdateProfilePic = (file: File) => {
    if (isLoading) return;

    dispatch({ type: 'SET_LOADING', payload: true });

    const bodyFormData = new FormData();
    bodyFormData.append('file', file);
    uploadFile(bodyFormData)
      .then((response) => response.data.data?.reference)
      .then((ref) => meUpdate({ photo: ref }))
      .then(() => syncUser(dispatch, true))
      .catch(handleApiGlobalError.bind(null, dispatch))
      .finally(() => dispatch({ type: 'SET_LOADING', payload: false }));
  };

  useEffect(() => {
    inputRef.current!.onchange = () => {
      const files = inputRef.current && inputRef.current.files;
      const file = files && files[0];

      if (!file) return;

      handleUpdateProfilePic(file);
    };
  }, []);

  if (!user) {
    return null;
  }

  // TODO: guardar info de banco
  // uservendedor
  // bankAccount: {bank: "Bancolombia", account: "0800100228", type: "Ahorros"}
  return (
    <div className={styles.container}>
      <h2>Ajustes</h2>

      <div className={styles.profileImg}>
        <img src={getProfilePic(user.photo)} />

        <input
          type="file"
          ref={inputRef}
          className={styles.input}
          accept="image/*"
        />

        <button className={styles.profileImgBtn}>
          <i className="fonticons fonticons-pencil" />
        </button>
      </div>

      <h3 className={styles.username}>
        {user.name}
        <p>
          {user.isVerified ? (
            <>
              <i className="fonticons fonticons-checked" />
              <span>Usuario verificado</span>
            </>
          ) : (
            'Usuario no verificado'
          )}
        </p>
        {user.role === 'vendedor' && <p>Vendedor</p>}
        {user.role === 'comprador' && <p>Comprador</p>}
      </h3>

      <div className={styles.content}>
        <FormUpdateUserField label="Nombre" name="name" />
        <FormUpdateUserField label="Apellidos" name="lastName" />
        <FormUpdateUserField
          label="Correo electrónico"
          name="email"
          type="email"
        />
        <FormUpdateUserField
          label="Contraseña"
          name="password"
          type="password"
        />

        <FormUpdateUserField label="Celular" name="phone" />

        <FormUpdateUserField
          label="Tipo de documento"
          name="document.type"
          type="select"
          selectOptions={formOptions?.document.map((el) => ({
            name: el,
            value: el,
          }))}
        />

        <FormUpdateUserField
          label="Número del documento"
          name="document.number"
        />

        <h4 className={styles.inlineField}>
          Cuenta bancaria
          <button onClick={() => setShowBankAccountModal(true)}>Editar</button>
        </h4>

        <h4 className={styles.inlineField}>
          Mis Planes
          <button onClick={() => setShowMyPlansModal(true)}>Ver</button>
        </h4>

        {isSeller && (
          <>
            <FormUpdateUserField
              label="Tipo de vendedor"
              name="sellerType"
              type="select"
              selectOptions={formOptions?.sellerType.map((el) => ({
                name: el,
                value: el,
              }))}
            />
            <FormUpdateUserField label="Razón social" name="company" />
            <FormUpdateUserField
              label="Descripción profesional"
              name="proffessionalDescription"
            />

            <FormUpdateUserField label="País" name="address.country" />
            <FormUpdateUserField label="Estado" name="address.state" />
            <FormUpdateUserField label="Ciudad" name="address.city" />
            <FormUpdateUserField label="Dirección" name="address.name" />
          </>
        )}
      </div>

      <BankAccountModal
        open={showBankAccountModal}
        user={user}
        onClose={() => setShowBankAccountModal(false)}
      />

      <MyPlansModal
        open={showMyPlansModal}
        onClose={() => setShowMyPlansModal(false)}
      />
    </div>
  );
}
